import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzn8n7fhyr: FaireProductEntity = {
  token: "p_rzn8n7fhyr",
  type: "product",
  name: "Travel Jewelry Organizer, Blue Plaid Floral",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/f87e921a87a68d1e3d781a9f82ec6c61caccfd42947c118e1313f1c0d3cad5dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6801e0ff46b92b37949246704fc11924e2639faf8334c4993f425b1f447916a9.jpeg",
    "https://cdn.faire.com/fastly/0c58babfee6face13c52f20c1731e8001346b3673a8ea1913abf6ab44e49f375.jpeg",
    "https://cdn.faire.com/fastly/389bde14ca5d88112eb011ffce0a0d4d6b600a0b7a6153ea4e74050fa6506da7.jpeg",
    "https://cdn.faire.com/fastly/b0460565560f4197e030217f68430eb91f1445c659cdd6a4289be4e0eb63813d.jpeg"
  ],
  priceDollars: 12,
  description: "Say goodbye to missing earrings and knotted necklaces. This travel jewelry organizer is not only super cute, it’s got four lined compartments, three necklace hooks, and six ring rolls for keeping all your accessories organized and safe!\n\nProduct Details: \nDimensions: 4 in. x 4 in.\nCotton exterior\nFaux suede interior\nThree necklace hooks + elastic pouch\n4 compartments\n6 ring rolls\n\nFeatures:\nFour soft, lined compartments for earrings, bracelets, and small accessories\nThree dedicated necklace hooks to help prevent tangles and knots\nSix ring rolls for neatly securing rings and other delicate pieces\nCompact, travel-friendly design that fits easily into a suitcase, overnight bag, or carry-on\nCute, giftable design with the colorful, playful spirit ban.do is known for\nHelps keep jewelry organized, protected, and easy to find on the go\n\nIdeal For:\nGift shops and lifestyle boutiques\nFashion and accessory retailers\nTravel and luggage collections\nJewelry and specialty gift shops\nStores looking for fun, functional giftable accessories\nBridal, birthday, graduation, and holiday gifting\nCustomers who love stylish organization and travel accessories",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:18.487Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
